import React from 'react'

import { ReactComponent as CloseLogo } from '@percent/admin-dashboard/common/assets/images/close.svg'
import { Box, Divider, Text } from '@percent/lemonade'
import style from './Dialog.module.scss'

type DialogHeaderProps = {
  onClose: () => void
  headerTitle?: string
}

export function DialogHeader({ headerTitle, onClose }: DialogHeaderProps) {
  return (
    <>
      <Box id={style.dialogHeader}>
        <Text className={style.headerTitle}>{headerTitle}</Text>
        <button id={style.btnCloseDialog} onClick={onClose} type="button" data-testid="close-button" title="Close">
          <CloseLogo />
        </button>
      </Box>
      <Divider className={style.dialogMargin} />
    </>
  )
}
